import { useOpenClose } from 'core/hooks/useOpenClose';
import { Messages } from '../Messages';
import { topLevelNavigations } from '../topLevelNavigations';
import { useCurrentUserEmsTeam } from '../hooks/useCurrentUserEmsTeam';
import { Link } from 'react-router-dom';

/** メニューのコンポーネント。 */
export const Menu = () => {
  const { isOpen, handleOpen, handleClose } = useOpenClose();
  const { emsTeam } = useCurrentUserEmsTeam();

  return isOpen ? (
    <div className="fixed inset-0 bg-background min-h-screen z-10">
      <div className="flex justify-end bg-surface px-[40px] py-[20px]">
        <div className="flex flex-col">
          <button onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className="flex flex-col items-center pt-[64px] gap-[32px]">
        {topLevelNavigations.map((navigation, index) =>
          navigation.isMessages ? (
            emsTeam?.accessLevel === "DEPARTMENT" ? (
              <div key={index} onClick={handleClose}>
                <Messages />
              </div>
            ) : null
          ) : (
            <Link key={index} to={navigation.url} onClick={handleClose}>
              <p className="text-[18px] text-textPrimary noto-sans-jp-bold">
                {navigation.displayName}
              </p>
            </Link>
          )
        )}
      </div>
    </div>
  ) : (
    <div className="flex flex-col justify-center">
      <button onClick={handleOpen}>
        <MenuIcon />
      </button>
    </div>
  );
};

const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-7"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-7"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  );
};
